import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'kl-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss']
})
export class KlConfirmDialogComponent implements OnInit {

  message: string = '';

  constructor() { }

  ngOnInit(): void {

  }
}
